import { errorHandler } from "@/services/toastHandler";

const initState = () => ({
  loading: false,
  saving: false,
});

const displaySettingsModule = {
  namespaced: true,
  state: initState(),
  mutations: {
    LOADING: (s, data) => (s.loading = data),
    SAVING: (s, data) => (s.saving = data),
  },

  actions: {
    async getDisplaySettings({ commit }) {
      commit("LOADING", true);
      try {
        const res = await this.$api.get("/v1/portal/settings/detail", {
          params: { key: "display-settings" },
        });
        return res.data.data;
      } catch (e) {
        errorHandler(e);
      } finally {
        commit("LOADING", false);
      }
    },
    async updateDisplaySettings({ commit }, value) {
      commit("SAVING", true);
      try {
        const res = await this.$api.post("/v1/portal/settings/update", {
          key: "display-settings",
          value,
        });
        return res.data;
      } catch (e) {
        errorHandler(e);
      } finally {
        commit("SAVING", false);
      }
    },
  },
};

export default displaySettingsModule;
